<template>
    <ContainerWithMenu>
        <div class="page-content">
            <div class="row margin-bottom-20">
                <div class="col-xs-12 col-md-5">
                    <h1 class="h2 margin-0">{{ $t('common.calendar') }}</h1>
                </div>
                <div class="col-xs-12 col-md-7 text-right">
                    <button
                            class="btn btn-primary btn-action-mobile"
                            @click="newReservationModalVisible = true"
                    >
                        <i class="las la-calendar-plus"></i>
                        <span class="button-text">{{ $t('views.reservations.new') }}</span>
                    </button>
                </div>
            </div>
            <VueCal
                    :class="{ 'calendar-mobile' : isMobile }"
                    class="vuecal--blue-theme"
                    :disable-views="disableViews"
                    :locale="$i18n.locale"
                    id="vuecal"
                    :events="events"
                    events-on-month-view="short"
                    :time-cell-height="timeCellHeight"
                    :on-event-click="onEventClick"
                    @view-change="fetchAppointments"
                    @ready="fetchAppointments"
                    :time-from="hourStartMinutes"
                    :time-to="hourEndMinutes"
                    :active-view="activeView"
            >

            </VueCal>
        </div>
        <SpinnerLoader v-show="loading"></SpinnerLoader>
        <NewReservationModal v-show="newReservationModalVisible"
                             :visible="newReservationModalVisible"
                             @success-new-reservation="onSuccessNewReservation"
                             @close-new-reservation-modal="newReservationModalVisible=false"></NewReservationModal>
        <CalendarAppointmentModal
                :appointment-id="selectedAppointmentId"
                v-show="showAppointmentDetailModal"
                :visible="showAppointmentDetailModal"
                @close-calendar-appointment-modal="closeCalendarModal"></CalendarAppointmentModal>
    </ContainerWithMenu>
</template>


<style>


    .vuecal__event-title {
        font-weight: bold;
    }

    .vuecal__event {
        cursor: pointer;
        background-color: rgba(76, 172, 175, 0.35);
    }
    .vuecal--week-view .vuecal__time-cell {height: 300px;}

    .vuecal--month-view .vuecal__cell {height: 100px;}

    .vuecal--month-view .vuecal__cell-content {
        justify-content: flex-start;
        height: 100%;
        align-items: flex-end;
    }

    .vuecal--month-view .vuecal__cell-date {padding: 4px;}
    .vuecal--month-view .vuecal__no-event {display: none;}

    .vuecal__event-time {
        display: none;
    }
</style>

<script>
    import ContainerWithMenu from "@/components/container/ContainerWithMenu";
    import VueCal from 'vue-cal'
    import 'vue-cal/dist/i18n/it.js'
    import 'vue-cal/dist/vuecal.css'
    import {getAppointments} from "@/api";
    import SpinnerLoader from "@/components/common/SpinnerLoader";
    import { isMobile } from 'mobile-device-detect';
    import CalendarAppointmentModal from "../components/modal/CalendarAppointmentModal";
    import NewReservationModal from "../components/modal/NewReservationModal";
    import i18n from '../i18n'
    import {Utils} from "../common/utils";
    export default {
        title: i18n.t('common.calendar'),
        name: "Calendar",
        components: {ContainerWithMenu, VueCal, SpinnerLoader, CalendarAppointmentModal, NewReservationModal},
        data() {
            return {
                newReservationModalVisible: false,
                disableViews: isMobile ? ['years', 'year', 'month', 'week'] : ['years', 'year'],
                activeView: isMobile ? 'day' : 'week',
                hourStartMinutes: 0,
                hourEndMinutes: 24*60,
                timeCellHeight: 100,
                appointments: [],
                startDate: null,
                endDate: null,
                loading: false,
                showAppointmentDetailModal: false,
                selectedAppointmentId: 0,
                events: []
            }
        },

        computed: {
            isMobile: function () {
                return isMobile
            }
        },

        methods: {
            getHourString(date){
                return Utils.getHourStringFromISO(date)
            },
            onSuccessNewReservation() {
                this.newReservationModalVisible = false;
                this.getAppointments(this.startDate, this.endDate, false);
            },
            closeCalendarModal() {
                this.showAppointmentDetailModal=false;
                this.getAppointments(this.startDate, this.endDate, false);
            },
            onEventClick (event, e) {
                if (!event.canceled) {
                    this.selectedAppointmentId = event.id;
                    this.showAppointmentDetailModal = true;
                    e.stopPropagation()
                }
            },
            fetchAppointments ({startDate, endDate }) {
                this.startDate = startDate;
                this.endDate = endDate;
                this.getAppointments(startDate, endDate)
            },
            async getAppointments(startDate, endDate, loading = true) {
                this.loading = loading;
                try {
                    const calendar = document.querySelector('#vuecal .vuecal__bg');
                    calendar.scrollTo({ top: 0 });
                    let appointmentsResult = await getAppointments(startDate.toISOString(), endDate.toISOString());
                    this.hourStartMinutes = 0;
                    this.hourEndMinutes = 24 * 60;
                    this.appointments = appointmentsResult.results;
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            }

        },
        watch: {
            appointments(newVal) {
                let events = [];
                let minHour = 24;
                let maxHour = 0;

                newVal.forEach(appointment => {
                    let date_event = new Date(appointment.date);
                    let end_date_event = new Date(appointment.end_date);

                    let event = {
                        id: appointment.id,
                        start: date_event,
                        end: end_date_event,
                        canceled: appointment.canceled,
                        title: appointment.rate_name + " (" + appointment.reservation_count + "/" + appointment.max_participant + ")",
                        content: "<p>"+ this.getHourString(date_event) + " - " + this.getHourString(end_date_event) +"</p>"
                    };

                    if (appointment.is_online && !appointment.canceled) {
                        event.content += "<span class='badge'>ONLINE</span>"
                    } else if (appointment.canceled) {
                        event.content += "<span class='label label-danger'>Cancellata</span>"
                    }
                    events.push(event);

                    let hourStartEvent = date_event.getHours();
                    let hourEndEvent = end_date_event.getHours();
                    if (hourStartEvent < minHour) {
                        minHour = hourStartEvent
                    }

                    if (hourEndEvent < minHour) {
                        minHour = hourEndEvent
                    }

                    if (hourEndEvent > maxHour) {
                        maxHour = hourEndEvent + 1
                    }

                    if (hourStartEvent > maxHour) {
                        maxHour = hourStartEvent + 1
                    }

                });

                if (!isMobile) {
                    if (newVal.length === 0) {
                        minHour = 0;
                        maxHour = 0;
                    }
                    this.hourStartMinutes = minHour * 60;
                    this.hourEndMinutes = maxHour * 60;

                } else {
                    const calendar = document.querySelector('#vuecal .vuecal__bg');
                    calendar.scrollTo({ top: minHour * this.timeCellHeight});
                }


                this.events = events;

            }
        }
    }
</script>
